import React from 'react';
import { Calendar } from 'primereact/calendar';
import moment from 'moment/moment';

const DatePickerInstance = ({ selectedDate, updateDate }) => {
	const selected = selectedDate ? moment(selectedDate).toDate() : '';

	const _updateDate = ({ value }) => {
		if (value) {
			updateDate(moment(value).format('MM/DD/YYYY'));
		}
	};

	const onClear = () => updateDate(null);

	return (
		<Calendar
			value={selected}
			onChange={_updateDate}
			onClearButtonClick={onClear}
			dateFormat="mm/dd/yy"
			panelClassName="credential-modal-date-picker"
			placeholder="Select..."
			showButtonBar
		/>
	);
};

export default DatePickerInstance;
